import React, { useEffect } from "react";
import logo from "../../../assets/ultragenyx.png";
import { connect } from "react-redux";
import {
  mapStateToPropsFooter,
  mapStateToPropsLayout,
  mapDispatchToPropsLayout,
} from "../../../modules/layout";
import { mapStateToPropsLogin } from "../../../modules/login";
import moment from "moment";
import styled, { withTheme } from "styled-components";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { urlStudies } from "../../../modules/constants";
import { currentStudy } from "../../../config";

const StyledFooter = styled.footer`
  background-color: ${(props) => props?.theme?.white};
  color: ${(props) => props?.theme?.fg};
  border-top: 17px solid ${(props) => props?.theme?.yellowGreen};
`;

const Footer = (props) => {
  const { getBackendVersion, backendVersion, withSidebar, isLogged } = props;

  const { t } = useTranslation();

  useEffect(() => {
    getBackendVersion();
  }, [getBackendVersion]);

  const getMrcpText = () => {
    switch (currentStudy().toUpperCase()) {
      case urlStudies.gsdiii:
        return "MRCP-UX053-00009";
      case urlStudies.lcfaod401:
        return "MRCP-UX007-00191";
      case urlStudies.lcfaod402:
        return "MRCP-UX007-00489";
      case urlStudies.beyondxlh402:
        return "MRCP-KRN23-01553";
      default:
        return "MRCP-UX007-00191";
    }
  };

  return (
    <StyledFooter
      className={`page-footer font-small indigo pt-3 ${
        withSidebar && isLogged ? "" : "no-sidebar"
      }`}
    >
      <div className="container-fluid text-center text-md-left">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-4 col-md-3">
              <img
                src={logo}
                alt="logo"
                className="mt-2"
                style={{ height: "50px" }}
              />
            </div>
            <div className="col-sm-4 col-md-6 mt-3 text-center">
              <a
                href="https://www.ultragenyx.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="block__link small-link"
              >
                {t("appText.footer.privacyPolicy")}
              </a>
              |
              <a
                href="https://www.ultragenyx.com/cookie-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="block__link small-link"
              >
                {t("appText.footer.cookiePolicy")}
              </a>
              |
              <a
                href="https://www.ultragenyx.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="block__link small-link"
              >
                {t("appText.footer.contact")}
              </a>
            </div>
          </div>
          <hr className="mt-4" />
          <p>{t("contentText.footer.message")}</p>
          <p>
            <span data-testid="year-label">
              © {moment().format("YYYY")} Ultragenyx Pharmaceutical Inc.
            </span>
            <span data-testid="mrc-number" className="ml-3">
              {getMrcpText()}
            </span>
          </p>
          {isLogged && (
            <p>
              <span>
                <b>{t("appText.debug.frontendVersion")}:</b>{" "}
                {process.env.REACT_APP_VERSION} |{" "}
                <b>{t("appText.debug.backendVersion")}:</b> {backendVersion} |{" "}
                <a href="/debug">{t("appText.debug.debugInfo")}</a>
              </span>
            </p>
          )}
        </div>
      </div>
    </StyledFooter>
  );
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsFooter(state),
  ...mapStateToPropsLayout(state),
  ...mapStateToPropsLogin(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToPropsLayout
)(withTheme(Footer));
